import axios from "../httpConfig/http.js";

const urlApi = "api/configuration";

export function LoadConfiguration() {
  return axios.get(`${urlApi}`);
}
